// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator employees`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companies from 'modules/core/store/collections/companies'
import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'
import subscriptions from 'modules/billing/store/collections/subscriptions'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  /* employees manually fetched by 2 pages in this module */
  /* subscriptions manually fetched by 2 pages in this module */
  /* users manually fetched by 1 pages in this module */
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 3 cases in this module */,
    [companyHolidays, {}] /* Referenced by 12 cases in this module */,
    [employeeGroups, {}] /* Referenced by 2 cases in this module */,
    [features, {}] /* Referenced by 39 cases in this module */,
    [legalEntities, {}] /* Referenced by 4 cases in this module */,
    [subscriptions, {}] /* Referenced by 2 cases in this module */,
    [timeoffPolicies, {}] /* Referenced by 4 cases in this module */,
  ] /* Generated file 👉 artifacts/employees-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
